export default "<div class=\"content\" [innerHTML]=\"content\">\n";